import ExportForm from "presentation/components/Export/ExportForm";
import Spinner from "presentation/components/Shared/Spinner";
import usePermissionCheck from "presentation/hooks/use-check-permissions";
import React from "react";
import FunctionHeader from "../../components/Header/FunctionHeader";

const ExportPage = () => {
    const { isLoading } = usePermissionCheck({ requiredFunction: "exports" });

    if (isLoading) {
        return <Spinner />;
    }
    return (
        <div>
            <FunctionHeader title="Exportar Ficheiros" />
            <ExportForm />
        </div>
    );
};

export default ExportPage;
